export const INCREMENT_FETCH = "INCREMENT_FETCH";
export const DECREMENT_FETCH = "DECREMENT_FETCH";
export const INCREMENT_SUBMIT = "INCREMENT_SUBMIT";
export const DECREMENT_SUBMIT = "DECREMENT_SUBMIT";
